import { useTheme } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { BoxForm, Select } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import {
  interstitialAvailabilities,
  InterstitialAvailability,
} from 'features/inventory/domain/types/interstitialAvailability'
import { useAbility } from 'providers/casl'
import { interstitialAvailabilityColor } from './utils'

import type { Schema } from './schema'
import type { SelectOption } from 'components/Select/types'

export const EmployeeSettingsSection = (): React.JSX.Element => {
  const theme = useTheme()
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'form.richPlacements.interstitial.employeeSettings',
  })
  const { control } = useFormContext<Schema>()

  const ability = useAbility()
  const cannotUpdate: boolean =
    ability.cannot('update', 'Domain') ||
    ability.cannot('update', 'DomainRichPlacementsFeature-interstitialEmployeeSettings')

  return (
    <Paper
      data-cy='section-employee-settings'
      variant='cream'
    >
      <BoxForm>
        <SectionHeader
          subtitle={t('subtitle')}
          title={t('title')}
        />

        <Select<Schema, InterstitialAvailability>
          control={control}
          disabled={cannotUpdate}
          label={t('availability.label')}
          labelColor={({ value }) => interstitialAvailabilityColor({ availability: value, theme })}
          name='availability'
          options={interstitialAvailabilities.map(
            (availability: InterstitialAvailability): SelectOption<InterstitialAvailability> => ({
              label: t(`availability.options.${availability}`),
              value: availability,
            }),
          )}
          tooltip={{ content: t('availability.tooltip') }}
        />
      </BoxForm>
    </Paper>
  )
}
